export class DocumentTypeExpressionDefinitionApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getDocumentTypeExpressionDefinitionByDocumentTypeId({ documentTypeId }) {
    return this.#http.get(`/DocumentTypeExpressionDefinition/${documentTypeId}`);
  }
}
